// extracted by mini-css-extract-plugin
export default {"input":"GroupName_input__3VQvy","groupName":"GroupName_groupName__MfTEy","wrapper":"GroupName_wrapper__3VXM-"};